export default __webpack_public_path__ + "static/koenigsegg-890bcb1d183f9d87948db62239ada544.png";